import styles from './SearchButton.module.css'
import { SearchIcon2 } from 'shared/icons/SearchIcon2'
import classNames from 'classnames'


interface SearchButtonButtonProps {
    variant?: 'normal' | 'compact'
    className?: string
    onClick?: (event: any) => void
}

export const SearchButton = (props: SearchButtonButtonProps): JSX.Element => {
    const {
        variant = 'normal',
        className,
        onClick
    } = props

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    const searchButtonClasses = classNames(styles.SearchButton, className, {
        [styles[`SearchButton--Compact`]]: variant === 'compact'
    })

    if (variant === 'compact'){
        return (
            <button
                className={searchButtonClasses}
                onClick={handleButtonClick}
            >
                <span className={styles.SearchButton__IconContainer}>
                    <SearchIcon2 className={styles.SearchButton__Icon} />
                </span>
            </button>
        )
    }

    return (
        <button
            className={searchButtonClasses}
            onClick={handleButtonClick}
        >
            <span className={styles.SearchButton__IconContainer}>
                <SearchIcon2 className={styles.SearchButton__Icon} />
            </span>
             <span className={styles.SearchButton__Caption}>Search</span>
        </button>
    )
}